var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZhichengjiegou(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    clipPath: "url(#clip0_25_5143)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4773"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 658",
    d: "M16.0999 3.25457L12.3545 1.40002V6.34548L16.0999 8.49093V3.25457Z",
    fill: "#999999",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 659",
    d: "M12.4091 6.40909L1.07275 12.4364L5.15625 14.8437L16.7812 8.62497L12.4091 6.40909Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 657",
    d: "M4.64536 9.29095L0.899902 7.4364V12.3819L4.64536 14.5273V9.29095Z",
    fill: "#999999",
    stroke: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_5143"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZhichengjiegou);
export default __webpack_public_path__ + "static/media/zhichengjiegou.64e014bc71c591e590e73e1d5272fe7a.svg";
export { ForwardRef as ReactComponent };